import React from 'react';
import ReactDOM from 'react-dom';
import { NaveganteTemplateConfig } from '../..';

import App from '../../designs/paper/App';
import './plugins/fontawesome';

export default function render(
  callback?: (appElement: HTMLElement, config: NaveganteTemplateConfig) => void
) {
  const appElement = document.getElementById('app');
  const config = appElement?.dataset.config;

  if (!appElement || !config) {
    console.error('Missing app element or config');
    return;
  }

  const appConfig: NaveganteTemplateConfig = JSON.parse(config);

  try {
    ReactDOM.render(<App config={appConfig} />, appElement);
    if (callback) callback(appElement, appConfig);
  } catch (err) {
    console.error(err);
  }
}
